module.exports = __webpack_public_path__ + "img/cocktail-long.e6dc9149.svg";